import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import InputProfile from './InputProfile.react';
import AjaxPromises from '../../../utils/AjaxPromises';
import imageCompression from 'browser-image-compression';

class SecondaryIdentification extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmClear : false,
            loading : false,
            id      : this.props.IdentityId,
            stateId : this.props.data.StateId,
            image   : this.props.data.Image,
            name    : this.props.data.Name,
        };

        this.onChange = this.onChange.bind(this);
        this.onSecondaryIdChange = this.onSecondaryIdChange.bind(this);
        this.saveSecondaryId = this.saveSecondaryId.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    onSecondaryIdChange(e) {
        var reader = new FileReader();
        imageCompression(e.target.files[0], {
            maxSizeMB: 0.049,
            maxWidthOrHeight: 1080,
        })
            .then((compressedFile) => {
                reader.readAsDataURL(compressedFile);
            })
            .catch((error) => {
                NotificationActions.addNotification({type: 'error', body: error.message});
            });

        reader.onload = function(upload) {
            this.setState({ driversLicenseImg : this.dataURItoBlob(upload.target.result) }, () => {
                this.saveSecondaryId();
            });
        }.bind(this);
    }

    saveSecondaryId() {
        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;
        formData.driversLicenseNo    = this.state.driversLicenseNo;
        formData.ExpirationDate = this.state.driversLicenseExp+'T00:00:00';
        formData.Image        = this.state.driversLicenseImg;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(EndPoints.EDIT_SECONDARY_ID,
                formData).then(res => {

                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not updated'});
                    } else {
                        NotificationActions.addNotification({type:'success',body:'Image updated'});
                        this.props.onAdditionalIdChange();
                    }
                }
            );
        });
    }

    deleteImage() {
        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;
        formData.IdentityId     = this.props.data.IdentityId;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(EndPoints.REMOVE_SECONDARY_ID,
                formData).then(res => {

                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not removed'});
                    } else {
                        this.setState({ confirmClear : false, loading : false }, () => {
                            NotificationActions.addNotification({type:'success',body:'Image removed successfully'});

                            this.props.onAdditionalIdChange();
                        });
                    }
                }
            );
        });
    }

    dataURItoBlob(dataURI) {
        var byteString = false;

        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = dataURI.split(',')[1];
        }

        return byteString;
    }

    render() {
        var guest = this.props.guest;
        var image = this.state.image;

        return (

            <div style={{ marginBottom: '25px' }} className='row'>

                <div className='col-6'>
                    { this.state.image ?
                        <img
                            src={'data:image/png;base64, '+this.state.image}
                            className='view-identification__image' />
                    :
                        <img
                            src='/assets/id_placeholder.png'
                            className='view-identification__image' />
                    }
                </div>

                <div className='col-6'>
                    <div className='row'>
                        <div className='col-12'>

                            <InputProfile
                                field='name'
                                disabled={guest.IsAnonymous}
                                value={this.state.name}
                                placeHolder='Name'
                                onChange={this.onChange} />

                            <InputProfile
                                field='stateId'
                                disabled={guest.IsAnonymous}
                                value={this.state.stateId}
                                placeHolder='Number'
                                onChange={this.onChange} />

                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12'>
                            <div
                                className={'btn-green view-identification__btn '+(!guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={() => { 
                                    if (!guest.IsAnonymous) {
                                        $('#view-identification__dl').click(); 
                                    }
                                }}>

                                NEW
                            </div>

                            <div
                                className={'btn-green view-identification__btn '+(image && !guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={() => { this.setState({ confirmClear: (image && !guest.IsAnonymous ? true : false) }); }}>

                                CLEAR
                            </div>

                            <input
                                type='file'
                                accept='.jpg,.jpeg,.png,.tiff,.gif'
                                id='view-identification__dl'
                                className='view-identification__file'
                                onChange={this.onSecondaryIdChange} />
                        </div>
                    </div>

                    { this.state.confirmClear &&
                        <div className='popup'>
                            <div className='popup__content view-identification__clear'>
                                <div className='popup-header'>
                                    CLEAR IMAGE
                                    <div
                                        className='popup-close'
                                        onClick={() => { this.setState({ confirmClear : false }); }}>

                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>
                                </div>

                                <button
                                    onClick={() => { this.setState({ confirmClear : false }); }}>

                                    CANCEL
                                </button>

                                <button
                                    onClick={this.deleteImage}>

                                    CLEAR
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SecondaryIdentification;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/SecondaryIdentification.react.jsx